/* Copyright 2013 - 2024 Waiterio LLC */
import userAgent from './userAgent.js'

const automation = /automation/i.test(userAgent)

export default automation
